import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicFieldDropdown, BaasicFormControls, BaasicButton, BaasicModal } from 'core/components';
import { observer } from "mobx-react";
import { NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal } from "application/niko-facility-order-us-intake/components";
function NikoFacilityOrderUSIntakeFindAndReplaceModalTemplate({ nikoFacilityOrderUSIntakeFindAndReplaceModalStore, t }) {
	const {
		contentLoading,
		form,
		modalParams,
		currentProductStore,
		newProductStore,
		disabled,
		isDeleting,
		deleteFacilityOrderTemplateItems,
		isNewProductEmpty,
		nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal,
		isLoading
	} = nikoFacilityOrderUSIntakeFindAndReplaceModalStore;

	return (
		<Content loading={contentLoading}>
			<div className="modal__header">
				<h3 className='modal__header__title'>{t('FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.TITLE')}</h3>
			</div>
			<div className="modal__body">
				<div className="row">
					<div className="form__group col col-lrg-5">
						<BaasicFieldDropdown field={form.$('currentProductId')} store={currentProductStore} />
					</div>
					<div className="form__group col col-lrg-2 type--center u-mar--top--med">
						<label className="type--sml type--color--opaque">{t('FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.SWAP_TO')}</label>
					</div>
					<div className="form__group col col-lrg-5">
						<BaasicFieldDropdown disabled={disabled} field={form.$('newProductId')} store={newProductStore} allowEmpty={true} />
					</div>
				</div>
				<InventoryCalculationTable
					nikoFacilityOrderUSIntakeFindAndReplaceModalStore={nikoFacilityOrderUSIntakeFindAndReplaceModalStore}
					isCurrent={true}
				/>
				<InventoryCalculationTable
					nikoFacilityOrderUSIntakeFindAndReplaceModalStore={nikoFacilityOrderUSIntakeFindAndReplaceModalStore}
					isCutback={false}
				/>
			</div>
			<div className='modal__footer is-right'>
				<BaasicButton
					disabled={isDeleting || form.submitting || form.validating || isLoading}
					className='btn btn--med btn--light'
					label={t('EDIT_FORM_LAYOUT.CANCEL')}
					onClick={() => modalParams.close()}
				/>
				<BaasicButton
					className='btn btn--med btn--warning'
					label={t('EDIT_FORM_LAYOUT.DELETE')}
					onClick={() => deleteFacilityOrderTemplateItems()}
					disabled={(!isNewProductEmpty) || disabled || form.submitting || form.validating || isLoading}
					rotate icon={
						isLoading
							? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
							: 'u-display--none'
					}
				/>
				<BaasicFormControls
					form={form}
					className='btn btn--med btn--primary'
					onSubmit={form.onSubmit}
					disabled={isNewProductEmpty || disabled || form.submitting || form.validating}
					label={t('FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.SWAP')}
				/>
			</div>

			<BaasicModal modalParams={nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal} className="modal__content modal--lrg">
                <NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal />
            </BaasicModal>
		</Content>
	)
}

NikoFacilityOrderUSIntakeFindAndReplaceModalTemplate.propTypes = {
	nikoFacilityOrderUSIntakeFindAndReplaceModalStore: PropTypes.object,
	t: PropTypes.func
};

const InventoryCalculationTable = observer(({ nikoFacilityOrderUSIntakeFindAndReplaceModalStore, isCurrent }) => {
	const {
		currentProducts,
		newProducts
	} = nikoFacilityOrderUSIntakeFindAndReplaceModalStore;
	const items = isCurrent ? currentProducts : newProducts;
	return (
		items && items.some(i => i) ?
			<div className="u-mar--top--sml">
				<div className="type--wgt--bold">{isCurrent ? "Current:" : "New:"}</div>
				<table className="table--preview">
					<thead>
						<tr>
							<th width="20%" className="type--left">PATIENT NAME</th>
							<th width="9%" className="type--left">TEMP QTY</th>
							<th width="9%" className="type--left">SO QTY</th>
							<th width="24%" className="type--left">NOTE</th>
							<th width="20%" className="type--left">INACTIVE REASON</th>
						</tr>
					</thead>
					<tbody>
						{items.map((item) => {
							return (
								<tr key={item.id}>
									<td>{item.patientName}</td>
									<td>{item.quantity}</td>
									<td>{item.salesOrderQuantity}</td>
									<td>{item.note}</td>
									<td>{item.inactiveReason}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			:
			<React.Fragment></React.Fragment>
	);
});

InventoryCalculationTable.propTypes = {
	nikoFacilityOrderUSIntakeFindAndReplaceModalStore: PropTypes.object,
	isCurrent: PropTypes.bool
};

export default defaultTemplate(NikoFacilityOrderUSIntakeFindAndReplaceModalTemplate);
